import type { IPlanManageItem, IPlanManageRepository } from "~/interfaces/IPlanManageRepository";

export class PlanManageRepository implements IPlanManageRepository {
  async fetch(): Promise<{ plans: IPlanManageItem[] }> {
    const plans = await GetRequest<{ plans: IPlanManageItem[] }>(`/plan_manage`);
    return plans;
  }

  async updateMenuSort(planId: string, menuSort: Record<string, number>): Promise<void> {
    const jsonData = {
      menu_sort: {
        article: menuSort.article,
        document: menuSort.document,
        live_movie: menuSort.live,
        movie: menuSort.movie,
      },
    };
    const res = await PutRequest<{ statusCode: number }>(`/plan_manage/${planId}/menu_sort`, JSON.stringify(jsonData));
    if (!res || res.statusCode !== 200) {
      throw new Error("PlanManageRepository.updateMenuSort API Error");
    }
  }
}
